import React, { useCallback, useState } from 'react';
import { useLanguage } from '../../locale/useLanguage';
import Card from '../Card/Card';
import './PinBox.css';

type PinBoxProps = {
  pin: string;
};

export const PinBox: React.FC<PinBoxProps> = ({ pin }) => {
  const [t] = useLanguage();
  const [isPinVisible, setIsPinVisible] = useState<boolean>(false);

  const togglePinCode = useCallback(() => {
    setIsPinVisible((prev) => !prev);
  }, []);

  return (
    <Card>
      <div className="pin-box--container">
        <div className="pin-box--header">
          <p className="pin-box--pin">{isPinVisible ? pin : '****'}</p>
        </div>
        <button
          onClick={togglePinCode}
          className="pin-box--show-code clickable"
        >
          {isPinVisible ? t('home.hidePinCode') : t('home.showPinCode')}
        </button>
        <p className="pin-box--description">{t('home.pinCodeDescription')}</p>
      </div>
    </Card>
  );
};
